module.exports = __webpack_public_path__ + "img/logo-2.915f2ab5.png";